import { render, staticRenderFns } from "./reinsurance.vue?vue&type=template&id=42893ec4&"
import script from "./reinsurance.vue?vue&type=script&lang=js&"
export * from "./reinsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports